exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".align-checkbox-top[data-v-7b59479c] :deep(.v-input--selection-controls){margin-top:0;padding-top:0}.align-checkbox-top[data-v-7b59479c] :deep(.v-input--selection-controls__input){margin-top:2px!important}.align-checkbox-top[data-v-7b59479c] :deep(.v-label){align-self:flex-start;margin-top:0}.checkbox-content[data-v-7b59479c]{display:inline-block;margin-top:-4px}.checkbox-content a[data-v-7b59479c]{color:#1976d2;text-decoration:none}.checkbox-content a[data-v-7b59479c]:hover{text-decoration:underline}.align-checkbox-top[data-v-7b59479c] :deep(.v-input__slot){align-items:flex-start!important}", ""]);

// exports
